module.exports = __webpack_public_path__ + "static/media/bar.9e871f52.jpg";